<template>
  <div class="request_form">
    <form class="form-horizontal" @submit.prevent="submitForm">
      <fieldset>
        <legend>Embroidery Request</legend>
        <div class="form-group">
          <label class="control-label col-sm-4">Request Type</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.form_type">
              <option value="new">New</option>
              <option value="imperial_custom">Imperial Custom</option>
              <option value="special_events">Special Events</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">PO #</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.po_number" required>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">SO / CC #</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.cc_number">
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Log #</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.log_number">
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Division</label>
          <div class="col-sm-8">
            <v-select v-model="form.division" :options="divisionOptions" />
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Customer Name</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.customer_name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Customer #</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.customer_number" required>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Customer Email For Proof</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.customer_email_for_proofs">
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">CSR</label>
          <div class="col-sm-8">
            <v-select v-if="csrOptions.length" v-model="form.csr_name" :options="csrOptions" />
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Turn Time</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.turn_time">
              <option value="1 Day">1 Day</option>
              <option value="Rush">Rush</option>
              <option value="24 Hour">24 Hour</option>
            </select>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Request Details</legend>
        <div class="form-group">
          <label class="control-label col-sm-4">Revise Request</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.revise">
              <option :value="0">No</option>
              <option :value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Deliver Stitchout</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.deliver_stitchout">
              <option :value="0">No</option>
              <option :value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Pickleball</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.pickleball">
              <option :value="0">No</option>
              <option :value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Stitch Type</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.stitch_type">
              <option value="">Select Stitch Type</option>
              <option value="Cap">Cap</option>
              <option value="Flat Panel">Flat Panel</option>
              <option value="Paper Proof">Paper Proof</option>
            </select>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Tapes</legend>
        <div v-for="(tape, index) in form.tapes" :key="'tape-' + index" class="request-card">
          <div class="form-group">
            <label class="control-label col-sm-4">Tape Name</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="tape.name">
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-sm-4">Technique</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="tape.technique">
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-sm-4">Position</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="tape.position">
            </div>
          </div>
        </div>
        <div class="request-actions">
          <button type="button" class="btn btn-light btn-sm" @click="addTape">Add Tape</button>
          <button type="button" class="btn btn-light btn-sm" @click="removeTape" :disabled="form.tapes.length <= 1">Remove Tape</button>
        </div>
      </fieldset>

      <fieldset>
        <legend>Styles</legend>
        <div v-for="(cap, index) in form.caps" :key="'cap-' + index" class="request-card">
          <div class="form-group">
            <label class="control-label col-sm-4">Style</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="cap.style">
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-sm-4">Color</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="cap.color">
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-sm-4">Thread Color</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="cap.thread_color">
            </div>
          </div>
        </div>
        <div class="request-actions">
          <button type="button" class="btn btn-light btn-sm" @click="addCap">Add Style</button>
          <button type="button" class="btn btn-light btn-sm" @click="removeCap" :disabled="form.caps.length <= 1">Remove Style</button>
        </div>
      </fieldset>

      <fieldset>
        <legend>Comments</legend>
        <div class="form-group">
          <label class="control-label col-sm-12" style="text-align:left;">Request Comments</label>
          <div class="col-sm-12">
            <textarea class="form-control" rows="6" v-model="form.comments" required></textarea>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-12" style="text-align:left;">CSR Comments</label>
          <div class="col-sm-12">
            <textarea class="form-control" rows="4" v-model="form.csr_comments"></textarea>
          </div>
        </div>
      </fieldset>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary">Submit Request</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { buildRequestPrefill } from './request_prefill'

function blankTape () {
  return {
    number: '',
    name: '',
    technique: '',
    position: '',
    thread_color: ''
  }
}

function blankCap () {
  return {
    style: '',
    color: '',
    thread_color: ''
  }
}

export default {
  name: 'EmbroideryRequest',
  props: ['newData', 'group'],
  data () {
    return {
      csrOptions: [],
      divisionOptions: ['ADG', 'Amusement', 'ASI', 'Branded Apparel', 'Fashion Brands', 'Imperial', 'Retail', 'Team Dealer'],
      form: {
        form_type: 'new',
        po_number: '',
        cc_number: '',
        log_number: '',
        division: 'Imperial',
        customer_name: '',
        customer_number: '',
        customer_email_for_proofs: '',
        csr_name: '',
        turn_time: '1 Day',
        revise: 0,
        deliver_stitchout: 0,
        pickleball: 0,
        royalty_logo: false,
        licensed_logo: false,
        stitch_type: '',
        comments: '',
        csr_comments: '',
        tapes: [blankTape()],
        caps: [blankCap()]
      }
    }
  },
  mounted () {
    this.getCsrs()
    this.applyPrefill()
  },
  methods: {
    getCsrs () {
      axios.post(this.$apiAdress + '/api/flow/getCsrs?token=' + localStorage.getItem('api_token')).then(response => {
        this.csrOptions = (response.data || []).map(user => ({
          value: user.id,
          label: user.name
        }))
      })
    },
    applyPrefill () {
      if (!this.newData) return
      const prefill = buildRequestPrefill(this.newData, this.group || {})
      this.form.po_number = prefill.orderId ? String(prefill.orderId) : ''
      this.form.cc_number = prefill.ccNumber
      this.form.log_number = prefill.logNumber
      this.form.customer_name = prefill.customerName
      this.form.customer_number = prefill.customerNumber
      this.form.division = prefill.programName || 'Imperial'
      this.form.comments = prefill.comments
      this.form.csr_comments = prefill.sectionName || ''
      this.form.stitch_type = prefill.techniqueName && prefill.techniqueName.toLowerCase().indexOf('flat') > -1 ? 'Flat Panel' : 'Cap'
      this.form.tapes = [Object.assign(blankTape(), {
        name: prefill.artworkName || prefill.title,
        technique: prefill.techniqueName,
        position: [prefill.locationCode, prefill.locationName].filter(Boolean).join(' - ')
      })]
      if (prefill.styles.length) {
        this.form.caps = prefill.styles.map(style => Object.assign(blankCap(), {
          style: style.style_name || '',
          color: style.style_description || '',
        }))
      }
    },
    addTape () {
      this.form.tapes.push(blankTape())
    },
    removeTape () {
      if (this.form.tapes.length > 1) {
        this.form.tapes.pop()
      }
    },
    addCap () {
      this.form.caps.push(blankCap())
    },
    removeCap () {
      if (this.form.caps.length > 1) {
        this.form.caps.pop()
      }
    },
    submitForm () {
      const postData = {
        form: this.form
      }
      axios.post(this.$apiAdress + '/api/flow/submitEmbroidery?token=' + localStorage.getItem('api_token'), postData).then(() => {
        this.$emit('submitted')
      })
    }
  }
}
</script>

<style scoped>
.request-card {
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #d8e2ee;
  border-radius: 8px;
  background: #f8fbff;
}

.request-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}
</style>
